import { createEngine, type Engine } from '@observant/engine-bindings';

/**
 * Load the Zig-built engine.wasm. The artifact is copied into this app's
 * public/ by `tools/copy-wasm.mjs`, so Vite serves it next to the document
 * (at the root in dev, under /game/ when embedded in the Astro site).
 */
export function loadEngine(): Promise<Engine> {
  const url = `${import.meta.env.BASE_URL}engine.wasm`;
  return createEngine(url);
}
